import { useCreateBlockNote } from "@blocknote/react";
import "@blocknote/core/fonts/inter.css";
import { BlockNoteView } from "@blocknote/mantine";
import "@blocknote/mantine/style.css";

export default function TextEditor({ initialContent, open, setValue }) {
  if(!open) return null;
  
  // Parse initial content safely
  let parsedContent;
  try {
    if (initialContent && typeof initialContent === 'string') {
      parsedContent = JSON.parse(initialContent);
    }
  } catch (e) {
    // If parsing fails, treat it as plain text and create a basic block
    if (initialContent) {
      parsedContent = [
        {
          type: "paragraph",
          content: initialContent,
        },
      ];
    }
  }

  const editor = useCreateBlockNote({
    initialContent: parsedContent,
  });

  return (
    <div className="text-editor-wrapper">
      <style>{`
        /* Force light mode for BlockNote editor */
        .text-editor-wrapper,
        .text-editor-wrapper * {
          color-scheme: light !important;
        }
        
        .text-editor-wrapper .bn-container,
        .text-editor-wrapper .bn-container * {
          background-color: white !important;
          color: #111827 !important;
        }
        
        .text-editor-wrapper .bn-container .bn-editor {
          font-size: 0.875rem;
          line-height: 1.5;
        }
        
        .text-editor-wrapper .bn-container .bn-editor p {
          font-size: 0.875rem;
        }
        
        .text-editor-wrapper .bn-container .bn-editor p,
        .text-editor-wrapper .bn-container .bn-editor h1,
        .text-editor-wrapper .bn-container .bn-editor h2,
        .text-editor-wrapper .bn-container .bn-editor h3,
        .text-editor-wrapper .bn-container .bn-editor li,
        .text-editor-wrapper .bn-container .bn-editor div,
        .text-editor-wrapper .bn-container .bn-editor span {
          font-family: inherit;
        }
        
        /* Ensure all interactive elements are visible */
        .text-editor-wrapper button,
        .text-editor-wrapper input,
        .text-editor-wrapper select {
          background-color: white !important;
          color: #111827 !important;
          border-color: #d1d5db !important;
        }
        
        .text-editor-wrapper button:hover {
          background-color: #f3f4f6 !important;
        }
        
        /* Placeholder text */
        .text-editor-wrapper .bn-container .ProseMirror p.is-empty::before {
          color: #9ca3af !important;
        }
      `}</style>
      <BlockNoteView
        id="block-text-editor"
        editor={editor}
        onChange={() => {
          setValue(JSON.stringify(editor.document));
        }}
      />
    </div>
  )
}